import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { OverlayViewF as OverlayView, OVERLAY_MOUSE_TARGET, useGoogleMap } from '@react-google-maps/api';
import { Icon, IconWrapper, useThemeContext } from '@honda-canada/design-system-react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { DealersListContext } from '../DealersListContext';
import themeStyles from './EmbeddedGoogleMap.styles';
import { LIST_VIEW_IDENTIFIER, productLineMapMarkerName } from '../../utils/constants';
import useJSSComponentContext from '../../hooks/useJSSComponentContext';

const Marker = themeStyles.apply(IconWrapper, 'Marker');

const Markers = ({ markers }) => {
  const theme = useThemeContext();
  const googleMap = useGoogleMap();

  const { sitecoreContext } = useSitecoreContext();
  const productLine = sitecoreContext?.site?.name;
  const mapMarkerName = productLineMapMarkerName.get(productLine);

  // FIXME: This is only meant to be used for InventoryVariant
  const { componentName: isInventoryVariant } = useJSSComponentContext();

  const { setSelectedDealer, dealersList, isDealerModalOpen, setActiveView } = useContext(DealersListContext);

  if (!Array.isArray(markers) || markers.length === 0) {
    return null;
  }

  const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -height,
  });

  const handleMarkerClick = marker => {
    const dealer = dealersList.find(({ id }) => id === marker.id);
    if (!isDealerModalOpen) {
      setSelectedDealer(dealer);
      // FIXME: This is only meant to be used for InventoryVariant
      if (isInventoryVariant) setActiveView(LIST_VIEW_IDENTIFIER);
      // Center the marker on the map when selected
      googleMap.panTo(marker?.coordinates);
    }
  };

  const hasSelectedMarker = markers.some(marker => marker.isSelected);
  const resolveColor = () => {
    if (!hasSelectedMarker) {
      return theme.colors.mapMarker[0];
    }

    return isDealerModalOpen ? theme.colors.grey[1] : theme.colors.grey[0];
  };

  return (
    <>
      {markers.map(marker => (
        // Use OverlayView instead of Marker for custom Icon component support
        <OverlayView
          position={marker.coordinates}
          mapPaneName={OVERLAY_MOUSE_TARGET}
          key={marker.id}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <Marker
            isSelected={marker?.isSelected}
            data-testid={`cy-map-marker${marker?.isSelected ? '-selected' : ''}`}
            onClick={() => handleMarkerClick(marker)}
          >
            {marker.isSelected ? (
              <Icon name={mapMarkerName} color={theme.colors.mapMarker[1]} iconSize="large" />
            ) : (
              <Icon name={mapMarkerName} color={resolveColor()} iconSize="large" />
            )}
          </Marker>
        </OverlayView>
      ))}
    </>
  );
};

export default Markers;

Markers.defaultProps = {
  markers: [],
};

Markers.propTypes = {
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      coordinates: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
      }),
    }),
  ),
};
